import { DBLTable } from '@ui/components/elements'
import { DatableDataType, DatableLog } from '@ui/interfaces'

interface ExpandedProps {
  events: { input: DatableLog; output: DatableLog }[]
  isLoading: boolean
  dataSource: DatableDataType
  primaryKeys: string[]
}

export const Expanded = ({ events, isLoading, dataSource, primaryKeys }: ExpandedProps) => {
  return (
    <div className="h-[calc(100vh-11.25rem)]">
      <DBLTable
        tableData={events}
        loading={isLoading}
        dataSource={dataSource}
        tableType={'output'}
        defaultColumnOrder={[...primaryKeys]}
        hideHeaders={false}
        condensedStyle={false}
      />
    </div>
  )
}
